var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"station-base-container"},[(_vm.selectedNode.type != _vm.productCodes.station)?_c('BaseGroupTotal'):_c('BaseStationTotal'),(_vm.selectedNode.type != _vm.productCodes.station)?_c('BaseGroupList',{staticStyle:{"margin-top":"15px"}}):[_c('BaseStationList',{ref:"lightList1",staticStyle:{"margin-top":"15px"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }